
import { useLanguage } from './useLanguage';
import trCommon from '../i18n/local/tr/common';
import enCommon from '../i18n/local/en/common';

const translations = {
  tr: trCommon,
  en: enCommon,
};

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key: string): string => {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  return { t, language };
};
